import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=0a01cae0&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=0a01cae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a01cae0",
  null
  
)

export default component.exports